import { useParams } from 'react-router-dom';
import usePaymentProcessor from '../../../hooks/Payment/usePaymentProcessor';
import { useCurrencyFormat } from '../../../hooks/utils/useCurrencyFormat';
import Loader from '../../Loader';
import ModalBase from '../ModalBase';
import PaymentData from './PaymentData';
import PaymentInfo from './PaymentInfo';
const Payment = ({
  campaign,
  foundation,
  campaignId,
  foundationId,
  closeModal,
  isModalOpen,
  amount,
  recurrence,
}) => {
  const {
    processPayment,
    loading,
    transactionState,
    errorMessage,
    successMessage,
    resetTransactionState,
  } = usePaymentProcessor();
  const formatedAmount = useCurrencyFormat();
  const { company } = useParams();

  const handleFormSubmit = async (data) => {
    try {
      const paymentMethod = data.paymentMethod;
      const paymentData = {
        ...data,
        description: 'Pago de donación',
        bill: 'OR-1234',
        extra2: campaign
          ? `Campaña ${campaignId}`
          : `Fundación ${foundationId}`,
        company: company,
        foundationName: foundation,
      };
      await processPayment(paymentMethod, paymentData);
    } catch (error) {
      console.error('Error procesando el pago:', error);
    }
  };
  const handleCloseModal = () => {
    resetTransactionState();
    closeModal();
  };

  return (
    <ModalBase
      closeModal={handleCloseModal}
      isOpen={isModalOpen}>
      <div
        className={`modal-payment-container ${transactionState && 'message'}`}>
        {transactionState === 'processing' && (
          <>
            <h2>Transacción en proceso...</h2>
            <Loader />
          </>
        )}
        {transactionState === 'accepted' && (
          <>
            <div className='success-img' />
            <h2>{successMessage}</h2>
          </>
        )}
        {transactionState === 'rejected' && (
          <>
            <div className='error-img' />
            <h2>Lo sentimos, tu transacción fue rechazada.</h2>
            <h3>{errorMessage}</h3>
          </>
        )}
        {transactionState === 'error' && (
          <>
            <div className='error-img' />
            <h2>Ocurrió un error técnico con tu pago.</h2>
            <h3>{errorMessage}</h3>
          </>
        )}
        {transactionState === 'pse_pending' && (
          <>
            <div className='success-img' />
            <h2>Te hemos redirigido al banco para completar tu pago.</h2>
            <h3>Completa el proceso en la pestaña que se abrió. Una vez finalices, podrás cerrar esta ventana.</h3>
          </>
        )}
        {!loading && !transactionState && (
          <>
            <PaymentInfo
              campaign={campaign}
              foundation={foundation}
              amount={formatedAmount(amount)}
              recurrence={recurrence}
            />
            <PaymentData
              campaign={campaignId}
              foundation={foundationId}
              onSubmit={handleFormSubmit}
              amount={amount}
              recurrence={recurrence}
            />
          </>
        )}
        {loading && !transactionState && <Loader />}
      </div>
    </ModalBase>
  );
};

export default Payment;
